import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fb618d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "body" }

import { ref } from 'vue';
import { withDefaults, computed, watch } from 'vue';
import {
ChevronDownIcon
} from '@/components/atoms';
interface Props {
  title?: string
  noChevron?: boolean
  initialShow?: boolean
  noMargin?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomAccordion',
  props: {
    title: { default: '' },
    noChevron: { type: Boolean, default: false },
    initialShow: { type: Boolean, default: false },
    noMargin: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, noChevron: boolean, initialShow: boolean, noMargin: boolean };


const show = ref<boolean>(props.initialShow)

function toggle() {
  show.value = !show.value
}

function enter(el: any) {
  el.style.height = `${el.scrollHeight}px`
}

function leave(el: any) {
  el.style.height = ''
}

watch(
  () => props.initialShow,
  () => show.value = props.initialShow
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'my-2': !__props.noMargin})
  }, [
    _createElementVNode("div", {
      class: "d-flex align-center justify-space-between cursor-pointer",
      onClick: _withModifiers(toggle, ["prevent"])
    }, [
      (__props.title)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true),
      (!__props.noChevron)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["d-flex ml-3 button", {'rotate-invert': show.value}])
          }, [
            _createVNode(_unref(ChevronDownIcon))
          ], 2))
        : _renderSlot(_ctx.$slots, "titleArea", _mergeProps({
            key: 2,
            show: show.value,
            toggle: toggle
          }, _ctx.$attrs))
    ], 8, _hoisted_1),
    _createVNode(_Transition, {
      name: "accordion",
      onAfterEnter: leave,
      onEnter: enter,
      onAfterLeave: leave,
      onBeforeLeave: enter
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, show.value]
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

})